module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_adults-74894c2dc336ec20087a528094cad3a6.svg";